import { render, staticRenderFns } from "./RouteLayer.vue?vue&type=template&id=09728738"
import script from "./RouteLayer.vue?vue&type=script&lang=js"
export * from "./RouteLayer.vue?vue&type=script&lang=js"
import style0 from "./RouteLayer.vue?vue&type=style&index=0&id=09728738&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports